export default "__VITE_ASSET__ynpaqGsL__"